import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaginatorI18n {

    constructor(private readonly translate: TranslateService) { }

    public getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        this.refresh(paginatorIntl);
        return paginatorIntl;
    }

    public refresh(paginatorIntl: MatPaginatorIntl) {
        paginatorIntl.itemsPerPageLabel = this.translate.instant('MATERIAL.TABLE.ITEMS_PER_PAGE_LABEL');
        paginatorIntl.nextPageLabel = this.translate.instant('MATERIAL.TABLE.NEXT_PAGE_LABEL');
        paginatorIntl.previousPageLabel = this.translate.instant('MATERIAL.TABLE.PREVIOUS_PAGE_LABEL');
        paginatorIntl.firstPageLabel = this.translate.instant('MATERIAL.TABLE.FIRST_PAGE_LABEL');
        paginatorIntl.lastPageLabel = this.translate.instant('MATERIAL.TABLE.LAST_PAGE_LABEL');
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0 || pageSize === 0) {
            return this.translate.instant('MATERIAL.TABLE.RANGE_PAGE_LABEL_1', { length });
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return this.translate.instant('MATERIAL.TABLE.RANGE_PAGE_LABEL_2', { startIndex: startIndex + 1, endIndex, length });
    }
}